import {
  Box,
  Container,
  Typography,
  Stack,
  Button,
  Chip,
  Paper,
  Divider,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BoltIcon from "@mui/icons-material/Bolt";
import ShieldIcon from "@mui/icons-material/Shield";

export function HowItWorks() {
  const scrollOneScreen = () => {
    const prefersNoMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    const header = document.getElementById("site-header"); // поміняй ID, якщо інший
    const offset = header?.offsetHeight ?? 0;
    const vh = window.visualViewport?.height ?? window.innerHeight;
    window.scrollBy({
      top: vh - offset,
      behavior: prefersNoMotion ? "auto" : "smooth",
    });
  };

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 6, md: 10 },
        mb: { xs: 12, md: 20 },
        bgcolor: "background.default",
      }}
    >
      <Container maxWidth="lg">
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, md: 6 },
            borderRadius: 4,
            bgcolor: "background.paper",
            border: (t) => `1px solid ${t.palette.divider}`,
            boxShadow: "0 10px 34px rgba(0,0,0,.06)",
          }}
        >
          <Stack
            direction={{ xs: "column", md: "row" }}
            spacing={{ xs: 4, md: 6 }}
            alignItems={{ xs: "flex-start", md: "center" }}
            justifyContent="space-between"
          >
            <Stack spacing={2} sx={{ maxWidth: { md: 680 } }}>
              <Chip
                label="Interest-free bond help"
                color="secondary"
                variant="filled"
                sx={{ alignSelf: "flex-start", fontWeight: 700 }}
              />

              <Typography
                component="h1"
                variant="h3"
                sx={{
                  fontWeight: 900,
                  lineHeight: 1.1,
                  fontSize: { xs: "2rem", md: "2.75rem" },
                  color: "text.primary",
                }}
              >
                How it Works
              </Typography>

              <Typography
                variant="subtitle1"
                sx={{
                  color: "text.secondary",
                  fontSize: { xs: "1rem", md: "1.125rem" },
                }}
              >
                Looking to move into a new place but worried about the bond?
                BondPay helps Australians pay their bond on the same day,
                interest free.
              </Typography>

              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                sx={{ pt: 1 }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  href="/apply"
                  aria-label="Apply now with BondPay"
                >
                  Apply now
                </Button>
                <Button
                  variant="outlined"
                  color="secondary"
                  size="large"
                  onClick={scrollOneScreen}
                  aria-label="Learn more about how BondPay works"
                >
                  Learn more
                </Button>
              </Stack>

              <Divider sx={{ my: 2 }} />

              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 1.5, sm: 3 }}
                useFlexGap
                flexWrap="wrap"
              >
                <Stack direction="row" spacing={1} alignItems="center">
                  <CheckCircleIcon fontSize="small" />
                  <Typography variant="body2" color="text.primary">
                    No interest
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="center">
                  <BoltIcon fontSize="small" />
                  <Typography variant="body2" color="text.primary">
                    Same-day payout
                  </Typography>
                </Stack>
                <Stack direction="row" spacing={1} alignItems="center">
                  <ShieldIcon fontSize="small" />
                  <Typography variant="body2" color="text.primary">
                    No late fees
                  </Typography>
                </Stack>
              </Stack>
            </Stack>

            <Box
              sx={{
                flexShrink: 0,
                width: { xs: "100%", md: 420 },
                alignSelf: { xs: "stretch", md: "center" },
                display: { xs: "none", md: "block" },
              }}
            >
              <Paper
                elevation={0}
                sx={{
                  p: 0,
                  borderRadius: 3,
                  bgcolor: "background.default",
                  border: (t) => `1px solid ${t.palette.divider}`,
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    aspectRatio: { xs: "16 / 9", md: "4 / 3" },
                    width: "100%",
                  }}
                >
                  <Box
                    component="img"
                    src="/assets/how-it-works.jpg"
                    alt="Renter getting instant bond approval with BondPay"
                    loading="eager"
                    width="100%"
                    height="100%"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                </Box>
              </Paper>
            </Box>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
}
